import React from 'react';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export const RightArrowIcon: React.FC<Props> = ({
  color = '#8694A1',
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 16L14 12L10 8"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
